import { ChannelTemplateCategory } from "../../../../domain/channel-template-category";
import { ChannelTemplateRepository } from "../../../../domain/channel-template-repository";
import { ChannelTemplate } from "../../../../domain/channel-template";
import { HttpService } from "../../../http/http";
import { Injectable } from "@angular/core";
import { UserService } from "../../../../domain/user-service";

@Injectable()
export class ChannelTemplateRepositoryCached
  implements ChannelTemplateRepository
{
  channelTemplateCategories: Array<ChannelTemplateCategory> = [];
  channelTemplates: Array<ChannelTemplate> = [];

  constructor(
    private httpService: HttpService,
    private userService: UserService,
  ) {}

  init() {
    if (this.userService.getCurrentUser().isSuperUser) {
      // init templates and  categories
      const options = this.httpService.createDefaultRequestOptions();
      return this.httpService
        .getJSON("Channel/GetChannelTemplates", options)
        .then(
          (result: {
            success: boolean;
            message: Array<GetAllTemplatesResult>;
          }) => {
            this.channelTemplates = new Array<ChannelTemplate>();

            if (result.success && result.message != null) {
              this.channelTemplates = result.message.map((item) =>
                this.mapToChannenTemplate(item),
              );
            }

            return this.channelTemplates;
          },
        )
        .then((channelTemplates) => {
          const result: Array<ChannelTemplateCategory> =
            new Array<ChannelTemplateCategory>();
          const tempCategorisDictionary: object = {};

          if (channelTemplates != null) {
            channelTemplates.forEach((template: ChannelTemplate) => {
              const templateCategoris = template.categories;
              templateCategoris.forEach((category) => {
                if (!tempCategorisDictionary[category.id]) {
                  tempCategorisDictionary[category.id] = true;
                  result.push(category);
                }
              });
            });
          }

          this.channelTemplateCategories = result;
        });
    }
  }
  getAllChannelTemplateCategories(): Promise<Array<ChannelTemplateCategory>> {
    return Promise.resolve(this.channelTemplateCategories);
  }

  getAllTemplates(): Promise<Array<ChannelTemplate>> {
    return Promise.resolve(this.channelTemplates);
  }

  private mapToChannenTemplate(
    resultItem: GetAllTemplatesResult,
  ): ChannelTemplate {
    const channelCategories: Array<ChannelTemplateCategory> =
      new Array<ChannelTemplateCategory>();

    if (resultItem.Categories != null) {
      for (let i = 0; i < resultItem.Categories.length; i++) {
        const category: { Id: number; Name: string } = resultItem.Categories[i];
        channelCategories.push(
          new ChannelTemplateCategory(category.Id, category.Name),
        );
      }
    }

    return new ChannelTemplate(
      resultItem.ChannelId,
      resultItem.ChannelName,
      channelCategories,
      resultItem.ChannelDescription,
      resultItem.TrailerUrl,
    );
  }
}

interface GetAllTemplatesResult {
  ChannelId: number;
  ChannelDescription: string;
  ChannelName: string;
  TrailerUrl: string;
  Categories: Array<{ Id: number; Name: string }>;
}
